module.exports = __webpack_public_path__ + "static/media/islam.c8192b80.png";